import React, { useEffect, useState } from 'react';
import { Card, Container, Row } from 'react-bootstrap';
import { jwtDecode } from 'jwt-decode';
import { get, isEmpty } from 'lodash';
import DynamicForm from 'screens/common/dynamicForm';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import FalconCardHeader from 'components/common/FalconCardHeader';
import { useNavigate, useParams } from 'react-router-dom';
import { formSubmissionToast } from 'helpers/utils';
import { marketpriceApi } from 'api/endpoints/MarketPrice';
import { getTenantFromToken } from 'utils/routeUtils';

function MarketPrice(props) {
  const tenant = getTenantFromToken();
  const tns_tenant = '03534add672340809e2c70314b1ce20e';
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const { id } = useParams();
  const isEditMode = !!id;

  const fetchFormData = async () => {
    try {
      const formResponse = await marketpriceApi.createMarketPriceForm(
        tns_tenant
      );
      setData(formResponse.data.results);
    } catch (error) {
      console.error('Error fetching form data:', error);
      toast.error('Failed to load form data');
    }
  };

  const fetchEditFormData = async id => {
    try {
      const formResponse = await marketpriceApi.editMarketPriceForm(
        tns_tenant,
        id
      );
      setData(formResponse.data.results);
    } catch (error) {
      console.error('Error fetching form data:', error);
      toast.error('Failed to load form data');
    }
  };

  useEffect(() => {
    if (isEditMode) {
      fetchEditFormData(id);
    } else {
      fetchFormData();
    }
  }, [tns_tenant]);

  const handleFormSubmit = async formData => {
    try {
      let response;
      if (isEditMode) {
        try {
          response = await marketpriceApi.updateMarketPriceForm(
            tns_tenant,
            formData,
            id
          );
          formSubmissionToast(response, toast, 'Market Price', true);
          navigate(`/${tenant}/marketpriceReport`); // Navigate only after successful response
        } catch (updateErr) {
          formSubmissionToast(updateErr, toast, 'Market Price', true);
          return; // Stop further execution on error
        }
      } else {
        try {
          response = await marketpriceApi.submitMarketPrice(
            tns_tenant,
            formData
          );
          formSubmissionToast(response, toast, 'Market Price');
          navigate(`/${tenant}/marketpriceReport`); // Navigate only after successful response
        } catch (createErr) {
          formSubmissionToast(createErr, toast, 'Market Price');
          return; // Stop further execution on error
        }
      }
    } catch (err) {
      formSubmissionToast(err, toast, 'Unexpected error occurred');
    }
  };

  const header = (
    <div className="d-flex align-items-center">
      <div
        className="me-2 my-auto theme-control-toggle"
        onClick={() => navigate(`/${tenant}/marketpriceReport`)}
      >
        <div className="theme-control-toggle-label">
          <FontAwesomeIcon icon={faArrowLeft} className="fs-0" />
        </div>
      </div>
      <span>{isEditMode ? 'Edit Market Price' : 'Create Market Price'}</span>
    </div>
  );

  return (
    <Container>
      <Row>
        <Card className="mb-3">
          <Card.Header>
            <FalconCardHeader
              title={header}
              className="ps-lg-4"
              titleTag="h5"
              titleClass="mb-0"
              light
            />
          </Card.Header>
          <Card.Body>
            {!isEmpty(data) && (
              <DynamicForm
                data={data}
                header={true}
                onSubmit={handleFormSubmit}
                mode={isEditMode && 'edit'}
              />
            )}
          </Card.Body>
        </Card>
      </Row>
    </Container>
  );
}

export default MarketPrice;
